// extracted by mini-css-extract-plugin
export default {"congratsPop":"congratsPop_congratsPop__7rg8C","price":"congratsPop_price__vWVUp","contentWrpper":"congratsPop_contentWrpper__zJp-z"};